"use client";

import { useState } from "react";
import { createPortal } from "react-dom";
import styles from "./MileageHeroSideSection.module.scss";
import Text from "@components/atoms/Text";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { PAGE_TYPES } from "@constants/pageTypes";
import { getCarAvailability } from "@utils/carAvailability";
import MileageModal from "@components/molecules/MileageModal";

interface VariantButtonProps {
  fuelType: string;
  transmission: string;
  mileage: string;
  variantCount: number;
  variants: any[];
  isSellable: boolean;
  brandName: string;
  modelName: string;
  cityName: string;
  carAvailability: string;
}

export const VariantButton = ({
  fuelType,
  transmission,
  mileage,
  variantCount,
  variants,
  isSellable,
  brandName,
  modelName,
  cityName,
  carAvailability,
}: VariantButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = async () => {
    setIsModalOpen(true);

    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.MILEAGE_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_choose_a_variant",
        section: "Mileage page summary",
        car_availability: carAvailability || getCarAvailability(`${isSellable}`),
        city_name: cityName,
        vehicle_make: brandName,
        vehicle_model: modelName,
      },
    });
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardContent}>
          <Text className={styles.transmission}>{transmission}</Text>
          <Text className={styles.mileage}>{mileage}</Text>
        </div>
        <div className={styles.cardFooter} onClick={handleClick}>
          <Text className={styles.variantCount}>
            {variantCount}
            <span className={styles.variantLabel}>variants</span>
          </Text>
          <Image
            src={`${assetLoader()}/icons/Arrow_right.svg`}
            alt="Arrow_right"
            width={20}
            height={20}
            loading="lazy"
          />
        </div>
      </div>

      {typeof window !== "undefined" &&
        createPortal(
          <MileageModal
            isOpen={isModalOpen}
            onClose={handleClose}
            title={`Available in ${variantCount} variant${
              variantCount > 1 ? "s" : ""
            }`}
            variants={variants}
            preventScoll={true}
            isSellable={isSellable}
            segmentPageType={PAGE_TYPES.MILEAGE_PAGE}
            segmentActionName="tap_btn_variant"
            segmentSection="Mileage page summary"
            cityName={cityName}
            brandName={brandName}
            modelName={modelName}
            carAvailability={carAvailability}
          />,
          document.body
        )}
    </>
  );
};

